var map = {
	"./0.png": 37112,
	"./1.png": 58241,
	"./2.png": 17162,
	"./3.png": 49075,
	"./4.png": 51676,
	"./5.png": 87589,
	"./6.png": 59758,
	"./7.png": 59255,
	"./8.png": 42896
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11337;